import * as types from '../constant/actionTypes';

export function resetErrMsg() {
  return {
    type: types.RESET_ERR_MSG,
  };
}

export function setErrMsg(msg) {
  return {
    type: types.SET_ERR_MSG,
    payload: msg,
  };
}

export function unAuthUser() {
  return {
    type: types.UNAUTH_USER,
  };
}



// WEBPACK FOOTER //
// ./src/actions/index.js